/* eslint-disable react/prop-types,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
/* eslint-disable no-alert */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as userActions from '../../actions/userActions'
import * as activityActions from '../../actions/activityActions'
import * as objectiveActions from '../../actions/objectiveActions'
import * as goalActions from '../../actions/goalActions'
import * as Constants from '../../misc/Constants'
import Slider from '../common/Slider'
import Modal from 'react-modal'
import { Wizard, Steps, Step } from 'react-albus'
import Datetime from 'react-datetime'
import moment from 'moment'

// Import Icons
import PlayIcon from '../../assets/images/common/icons/activityMenu/playIcon.png'
import TrainIcon from '../../assets/images/common/icons/activityMenu/trainIcon.png'
import SocialIcon from '../../assets/images/common/icons/activityMenu/socialIcon.png'

import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import NewGoalTask from './Goals/NewGoalTask'
import ImageUploader from '../common/form/ImageUploader'
import ActiveCommunityNotice from '../common/ActiveCommunityNotice'

//Import Styles
import './LogActionsModal.scss'
import { getActiveCommunityId, postedToCommunityMessage } from '../../utility/activeCommunity'

const logActions = [
  {
    id: 1,
    titleKey: 'profile.logActions.actionPlayTitle',
    subtitleKey: 'profile.logActions.actionPlaySubtitle',
    icon: PlayIcon,
  },
  {
    id: 2,
    titleKey: 'profile.logActions.actionTrainTitle',
    subtitleKey: 'profile.logActions.actionTrainSubtitle',
    icon: TrainIcon,
  },
  {
    id: 3,
    titleKey: 'profile.logActions.actionGoalsTitle',
    subtitleKey: 'profile.common.addPrivateGoal',
    icon: SocialIcon,
  },
]

class LogActionsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      userId: this.props.user ? this.props.user.id : null,
      divisions: [225, 450, 900, 1350, 1800],
      actionSelected: -1,
      activityId: '',
      date: '',
      format: 1,
      holes: 0,
      yardage: 0,
      location: '',
      score: '',
      greens: '',
      putts: '',
      description: '',
      trainSession: {},
      issueTrophyFormUserId: this.props.user ? this.props.user.id : -1,
      issueTrophyFormObjectiveId: -1,
      currentEnrollment: {},
      isRankCompleted: false,
      putting: 0,
      chipping: 0,
      pitchShots: 0,
      wedges: 0,
      irons: 0,
      woods: 0,
      simulation: 0,
      bunkers: 0,
      goalName: '',
      goalVideo: '',
      goalDescription: '',
      goalSubjectId: 0,
      goalTaskArray: [0],
      goalTasks: [],
      goalLoader: false,
      submitClicked: false,
      goalImage: '',
      uploadPhotoFileSrc: '',
      uploadPhotoName: '',
      uploadPhotoFile: '',
      didUploadPhoto: false,
      uploadingPhoto: false,
      pictures: [],
      activityDate: moment().format(),
      shareScore: true,
    }
  }

  handleActionSelect = (id, next) => {
    this.resetForms()
    this.setState(
      {
        actionSelected: id,
      },
      () => {
        if (next) {
          next()
        }
      }
    )
  }

  handleShareScoreChange = (_event) => {
    this.setState((prevState) => ({ shareScore: !prevState.shareScore }))
  }

  activityDateChanged = (event) => {
    const startDate = moment(event, 'MM-DD-YYYY').format('MM-DD-YYYY')
    const setActivityDate = moment(startDate, 'MM-DD-YYYY').format()

    this.setState({
      activityDate: setActivityDate,
    })
  }

  logActionsWelcome = (next) => {
    const { showCreateGoal, current_user, t } = this.props
    if (showCreateGoal) { next() }
    return logActions.map((action) => {
      if (action.id === 3 && current_user.type === 'Student') {
        return null
      }
      return (
        <div
          className={`${
            current_user.type === 'Student' ? 'col-md-6' : 'col-md-4'
          }`}
          key={action.id}
        >
          <div
            className={`card log-action-card ${
              this.state.actionSelected === action.id
                ? 'log-action-card-active'
                : ''
            }`}
            onClick={() => this.handleActionSelect(action.id, next)}
          >
            <img
              src={action.icon}
              alt={t(action.titleKey)}
              className='log-action-image'
            />
            <h5 className='log-action-title'>{t(action.titleKey)}</h5>
            <h5 className='log-action-subtitle'>{t(action.subtitleKey)}</h5>
          </div>
        </div>
      )
    })
  }

  // Handle Form Logic

  resetForms = () => {
    this.setState({
      actionSelected: -1,
      activityId: '',
      date: '',
      format: 1,
      holes: 0,
      yardage: 0,
      fullTeeYardage: 0,
      location: '',
      score: '',
      greens: '',
      putts: '',
      trainSession: [],
      description: '',
      issueTrophyFormUserId: this.props.user ? this.props.user.id : -1,
      userId: this.props.user ? this.props.user.id : null,
      issueTrophyFormObjectiveId: -1,
      currentEnrollment: {},
      putting: 0,
      chipping: 0,
      pitchShots: 0,
      wedges: 0,
      irons: 0,
      woods: 0,
      simulation: 0,
      bunkers: 0,
      goalName: '',
      goalVideo: '',
      goalDescription: '',
      goalSubjectId: 0,
      goalTaskArray: [0],
      goalTasks: [],
      submitClicked: false,
      goalCompletion: 0,
      goalImage: '',
      uploadPhotoFileSrc: '',
      uploadPhotoFileSources: [],
      uploadPhotoName: '',
      uploadPhotoFile: '',
      didUploadPhoto: false,
      uploadingPhoto: false,
      pictures: [],
      activityDate: moment().format(),
      shareScore: true,
    })
  }

  resetSliders = () => {
    this.setState({
      putting: 0,
      chipping: 0,
      pitchShots: 0,
      wedges: 0,
      irons: 0,
      woods: 0,
      simulation: 0,
      bunkers: 0,
    })
  }

  postPlay = () => {
    const { t } = this.props
    const postedTo = postedToCommunityMessage(this.props.current_user, this.props.activeCommunityId, t)
    this.props.setActivityAdded(true)
    this.props.activity_actions
      .coachPostActivityPlay(this.state, getActiveCommunityId(this.props.current_user, this.props.activeCommunityId))
      .then((response) => {
        if (response) {
          this.props.actions
            .getUserPlayActivities(this.props.user.id)
            .then(() => {
              this.props.actions.getUserStats(this.props.user.id)
              this.props.actions.getUserActivities(this.props.user.id)
              this.props.closeLogActionsModalandUpdate()
              if (postedTo) {
                this.props.toggleValidationModal(true, postedTo)
              }
            })
        }
        this.resetForms()
        this.props.setActivityAdded(false)
      })
  }

  handleLogClick = () => {
    const { showCreateGoal, t } = this.props
    const { score, description, holes, yardage, fullTeeYardage } = this.state
    this.setState(
      {
        submitClicked: true,
        userId: this.props.user.id,
      },
      () => { // eslint-disable-line complexity
        if (this.state.actionSelected === 1) {
          if (score !== '' && description !== '' && holes !== 0) {
            if (
              yardage === 'fullTee' &&
              parseInt(fullTeeYardage, 10) < (parseInt(holes, 10) === 9 ? 1801 : 3601)
            ) {
              this.props.toggleValidationModal(
                false,
                t('profile.logActions.validateFullTeeYardage')
              )
            } else if ( !yardage || yardage === '0' ) {
              this.props.toggleValidationModal(
                false,
                t('profile.logActions.validateLevelYardage')
              )
            } else {
              this.postPlay()
            }
          } else {
            this.props.toggleValidationModal(
              false,
              t('profile.logActions.validatePlayFields')
            )
          }
        } else if (this.state.actionSelected === 2) {
          const trainSession = []
          if (this.state.putting >= 0) {
            trainSession.push({ type: 1, duration: this.state.putting })
          }
          if (this.state.chipping >= 0) {
            trainSession.push({ type: 2, duration: this.state.chipping })
          }
          if (this.state.pitchShots >= 0) {
            trainSession.push({ type: 3, duration: this.state.pitchShots })
          }
          if (this.state.wedges >= 0) {
            trainSession.push({ type: 4, duration: this.state.wedges })
          }
          if (this.state.irons >= 0) {
            trainSession.push({ type: 5, duration: this.state.irons })
          }
          if (this.state.woods >= 0) {
            trainSession.push({ type: 6, duration: this.state.woods })
          }
          if (this.state.simulation >= 0) {
            trainSession.push({ type: 7, duration: this.state.simulation })
          }
          if (this.state.bunkers >= 0) {
            trainSession.push({ type: 8, duration: this.state.bunkers })
          }

          const trainSessionDuration = trainSession.reduce((sum, trainType) => sum + trainType.duration, 0)

          if (trainSessionDuration === 0 && this.state.description === '') {
            this.props.toggleValidationModal(false, t('profile.logActions.validateTrainForm'))
          } else if (trainSessionDuration === 0) {
            this.props.toggleValidationModal(false, t('profile.logActions.validateTrainDuration'))
          } else if (this.state.description === '') {
            this.props.toggleValidationModal(false, t('profile.logActions.validateTrainDescription'))
          } else {
            this.props.activity_actions
              .coachPostActivityTrain(this.state, trainSession, getActiveCommunityId(this.props.current_user, this.props.activeCommunityId))
              .then((response) => {
                if (response) {
                  this.props.actions
                    .getUserTrainActivities(this.props.user.id, this.props.trainCurrentPage, this.props.perPage)
                    .then((res) => {
                      this.props.setTrainActivitiesPages(res.pagination?.total_pages)
                      this.props.actions.getUserStats(this.props.user.id)
                      this.props.actions.getUserActivities(this.props.user.id)
                      this.props.closeLogActionsModal()
                      this.props.toggleValidationModal(
                        true,
                        t('profile.logActions.practiceLoggedSuccess', {
                          firstName: this.props.user.first_name,
                          lastName: this.props.user.last_name,
                        }),
                        postedToCommunityMessage(this.props.current_user, this.props.activeCommunityId, t)
                      )
                    })
                }
                this.resetForms()
              })
            this.resetForms()
          }
        } else if (this.state.actionSelected === 4) {
          this.props.completeObjective()
          this.resetForms()
        } else if (this.state.actionSelected === 3 || showCreateGoal) {
          this.setState({
            goalLoader: true,
          })
          this.onSubmitTask()
        }
      }
    )
  }

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleHolesChange = (event) => {
    const { divisions, yardage } = this.state
    const newHoles = event.target.value

    const newDivisions = newHoles === '9' ? [225, 450, 900, 1350, 1800] : [450, 900, 1800, 2700, 3600]

    const newYardage = yardage * newDivisions[0] / divisions[0]

    this.setState({
      holes: newHoles,
      divisions: newDivisions,
      yardage: newYardage,
    })
  }

  onPuttingChange = (value) => {
    this.setState({
      putting: value,
    })
  }

  onChippingChange = (value) => {
    this.setState({
      chipping: value,
    })
  }

  onPitchChange = (value) => {
    this.setState({
      pitchShots: value,
    })
  }

  onWedgesChange = (value) => {
    this.setState({
      wedges: value,
    })
  }

  onIronsChange = (value) => {
    this.setState({
      irons: value,
    })
  }

  onWoodsChange = (value) => {
    this.setState({
      woods: value,
    })
  }

  onSimulationChange = (value) => {
    this.setState({
      simulation: value,
    })
  }

  onBunkersChange = (value) => {
    this.setState({
      bunkers: value,
    })
  }

  displayRankObjectives() {
    if (this.props.incompleteObjectives.length > 0) {
      return this.props.incompleteObjectives.map((objective) => this.displayRankObjective(objective))
    }
  }

  displayRankObjective(objective) {
    if (objective.is_completed === false) {
      return (
        <option value={objective.id} key={objective.id}>
          {objective.subject.name} : {objective.name}
        </option>
      )
    }
  }

  renderPlayTypes() {
    let { playTypes } = this.props
    const { current_user } = this.props

    playTypes = playTypes.filter((playType) => playType.id !== Constants.PLAY_TYPE.TOURNAMENT_ID)
    if (current_user?.type && current_user.type !== 'Coach') {
      playTypes = playTypes.filter((playType) => playType.id !== Constants.PLAY_TYPE.OP36_ID)
    }
    return playTypes.map((play) => (
      <option value={play.id} key={play.id}>
        {play.name}
      </option>
    ))
  }

  createGoalTask = () => {
    const taskArray = [...this.state.goalTaskArray]
    const lastNum = taskArray[taskArray.length - 1]

    const newNum = lastNum + 1

    taskArray.push(newNum)

    this.setState({
      goalTaskArray: taskArray,
    })
  }

  deleteGoalTask = () => {
    const taskArray = [...this.state.goalTaskArray]
    const goalArray = [...this.state.goalTasks]
    taskArray.splice(-1, 1)
    goalArray.splice(-1, 1)
    this.setState({
      goalTaskArray: taskArray,
      goalTasks: goalArray,
    })
  }

  renderGoalTasks = () => {
    const lastTaskIndex = this.state.goalTaskArray.lastIndexOf(
      this.state.goalTaskArray[this.state.goalTaskArray.length - 1]
    )
    return this.state.goalTaskArray.map((task, index) => (
      <NewGoalTask
        sendData={(getData) => {
          this.getData = getData
        }}
        key={index}
        index={index}
        onObjectChange={this.onObjectChange}
        lastIndex={lastTaskIndex}
      />
    ))
  }

  renderDivisions = () => {
    const { t } = this.props
    return this.state.divisions.map((div, index) => (
      <option value={div} key={index}>
        {t('profile.logActions.levelYards', { level: index + 1, yards: div })}
      </option>
    ))
  }
  //
  // handleTrainTypeChange = (changeEvent) => {
  //   const { t } = this.props
  //   const el = changeEvent.target
  //   const checked = el.checked
  //   const practiceType = el.dataset.practiceType
  //   const practiceTypeName = el.value
  //   const updated = this.state.trainSession
  //
  //   if (checked) {
  //     if (window.navigator.notification) {
  //       window.navigator.notification.prompt(
  //         t('profile.logActions.trainMinutesPrompt', { practiceType: practiceTypeName }), // message
  //         this.onPrompt.bind(this, practiceType), // callback to invoke
  //         [t('profile.logActions.trainPromptTitle')], // title
  //         [t('profile.logActions.ok'), t('common.cancel')], // buttonLabels
  //         '60' // defaultText
  //       )
  //     } else {
  //       const duration = prompt(
  //         t('profile.logActions.trainMinutesPrompt', { practiceType: practiceTypeName }),
  //         '60'
  //       )
  //       if (duration !== null) {
  //         updated[practiceType] = { type: practiceType, duration: duration }
  //       }
  //       this.setState({
  //         trainSession: updated,
  //       })
  //     }
  //   } else {
  //     delete updated[practiceType]
  //     this.setState({
  //       trainSession: updated,
  //     })
  //   }
  // }
  //
  // outputDuration(trainType) {
  //   const { t } = this.props
  //   if (this.state.trainSession[trainType] !== undefined) {
  //     // We have a duration
  //     return (
  //       <span style={{ marginLeft: '5px' }}>
  //         {t('profile.logActions.durationMins', {
  //           count: Number(this.state.trainSession[trainType]['duration']),
  //         })}
  //       </span>
  //     )
  //   } else {
  //     // We don't have a duration
  //     return <span />
  //   }
  // }

  // Render Forms
  renderTrainForm() {
    const { t } = this.props
    return (
      <div className='row d-flex align-items-center flex-column h-100 mt-5'>
        <div className='col-md-12 mx-auto'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('profile.logActions.activityDate')}</label>
                <Datetime
                  name='firstStartDate'
                  value={moment(this.state.activityDate).format('MM-DD-YYYY')}
                  onChange={this.activityDateChanged}
                  dateFormat='MM-DD-YYYY'
                  timeFormat={false}
                  inputProps={{ readOnly: true }}
                  className='date-time'
                  {...this.state}
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.field.description')}</label>
                <textarea
                  rows={3}
                  name='description'
                  className='form-control '
                  placeholder={t('profile.logActions.trainDescriptionPlaceholder')}
                  value={this.state.description}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('common.golf.putting')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.putting })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.putting}
                onChange={this.onPuttingChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('common.golf.chipping')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.chipping })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.chipping}
                onChange={this.onChippingChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('profile.logActions.pitchShots')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.pitchShots })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.pitchShots}
                onChange={this.onPitchChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('profile.logActions.wedges')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.wedges })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.wedges}
                onChange={this.onWedgesChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('common.golf.fullSwingIrons')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.irons })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.irons}
                onChange={this.onIronsChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('common.golf.fullSwingWoods')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.woods })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.woods}
                onChange={this.onWoodsChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('common.golf.onCoursePlaySimulation')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.simulation })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.simulation}
                onChange={this.onSimulationChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
            <div className='col-md-6'>
              <div className='train-title'>
                <p>{t('common.golf.bunkers')}</p>
                <p className='train-duration-pill'>
                  {t('profile.logActions.minsCount', { count: this.state.bunkers })}
                </p>
              </div>
              <Slider
                min={0}
                max={300}
                step={5}
                value={this.state.bunkers}
                onChange={this.onBunkersChange}
                trackStyle={{ backgroundColor: '#ff6633', height: 4 }}
                handleStyle={{
                  borderColor: '#ff6633',
                  backgroundColor: '#ff6633',
                }}
              />
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-md-6'>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
              <p className='refresh-sliders' onClick={this.resetSliders}>
                <i className='fa fa-refresh refresh-icon' aria-hidden='true' />{' '}
                {t('profile.logActions.resetSliders')}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderPlayForm() {
    const { t } = this.props
    return (
      <div className='row d-flex align-items-center flex-column h-100 mt-5'>
        <div className='col-md-12 mx-auto'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('profile.logActions.format')}</label>
                <select
                  onChange={this.handleInputChange}
                  value={this.state.format}
                  name='format'
                  className='form-control'
                >
                  {/* <option value={0} disabled>
                    Select Game Type
                  </option> */}
                  {this.renderPlayTypes()}
                </select>
              </div>
            </div>
            <div className='col-md-12'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.field.description')}</label>
                <textarea
                  rows={3}
                  name='description'
                  className='form-control '
                  placeholder={t('profile.logActions.playDescriptionPlaceholder')}
                  value={this.state.description}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('profile.logActions.activityDate')}</label>
                <Datetime
                  name='firstStartDate'
                  value={moment(this.state.activityDate).format('MM-DD-YYYY')}
                  onChange={this.activityDateChanged}
                  dateFormat='MM-DD-YYYY'
                  timeFormat={false}
                  inputProps={{ readOnly: true }}
                  className='date-time'
                  {...this.state}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.field.location')}</label>
                <input
                  type='text'
                  name='location'
                  className='form-control'
                  id='play-activity-location'
                  placeholder={t('common.field.location')}
                  onChange={this.handleInputChange}
                  value={this.state.location}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.golf.yardage')}</label>
                <select
                  onChange={this.handleInputChange}
                  value={this.state.yardage}
                  name='yardage'
                  className='form-control'
                >
                  <option value={0}>
                    {t('profile.common.selectLevel')}
                  </option>
                  {this.renderDivisions()}
                  <option value='fullTee' id='full-tee-box-option'>
                    {t('profile.logActions.fullTeeBoxOption')}
                  </option>
                </select>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('profile.logActions.fullTeeYardage')}</label>
                <input
                  type='number'
                  name='fullTeeYardage'
                  className='form-control'
                  id='play-activity-full-tee'
                  placeholder={
                    this.state.yardage === 'fullTee'
                      ? t('profile.logActions.enterFullTeeYardage')
                      : t('profile.logActions.chooseFullTeeOption')
                  }
                  disabled={this.state.yardage !== 'fullTee'}
                  onChange={this.handleInputChange}
                  onWheel={(e) => e.target.blur()}
                  value={
                    this.state.yardage !== 'fullTee'
                      ? ''
                      : this.state.fullTeeYardage
                  }
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.golf.score')}</label>
                <input
                  type='number'
                  name='score'
                  className='form-control'
                  id='play-activity-score'
                  placeholder={t('common.golf.score')}
                  onChange={this.handleInputChange}
                  onWheel={(e) => e.target.blur()}
                  value={this.state.score}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.golf.holes')}</label>
                <select
                  onChange={this.handleHolesChange}
                  value={this.state.holes}
                  name='holes'
                  className='form-control'
                >
                  <option value={0} disabled>
                    {t('profile.logActions.selectHoles')}
                  </option>
                  <option value={9}>{t('profile.logActions.holesCount', { count: 9 })}</option>
                  <option value={18}>{t('profile.logActions.holesCount', { count: 18 })}</option>
                </select>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.golf.greens')}</label>
                <input
                  type='number'
                  name='greens'
                  className='form-control'
                  id='play-activity-greens'
                  placeholder={t('profile.logActions.enterGreenCount')}
                  onChange={this.handleInputChange}
                  onWheel={(e) => e.target.blur()}
                  value={this.state.greens}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='program-activity-title'>{t('common.golf.putts')}</label>
                <input
                  type='number'
                  name='putts'
                  className='form-control'
                  id='play-activity-putts'
                  placeholder={t('profile.logActions.enterPuttCount')}
                  onChange={this.handleInputChange}
                  onWheel={(e) => e.target.blur()}
                  value={this.state.putts}
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mx-auto d-flex justify-content-center mb-5 mt-3'>
              <div className='custom-control custom-switch'>
                <input
                  type='checkbox'
                  className='custom-control-input'
                  id='shareScoreSwitch'
                  checked={this.state.shareScore}
                  onChange={this.handleShareScoreChange}
                />
                <label
                  className='custom-control-label'
                  htmlFor='shareScoreSwitch'
                >
                  {t('profile.logActions.shareScore')}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // renderGoalSwitcher() {
  //   const { t } = this.props
  //   return (
  //     <div className='row mx-auto pb-5 mb-5 log-action-goal-card-container'>
  //       <div
  //         className={`card log-action-card col-md-4 log-action-goal-card ${
  //           this.state.actionSelected === 4 ? 'log-action-card-active' : ''
  //         }`}
  //         onClick={() => this.handleActionSelect(4)}
  //       >
  //         {/* <img src={action.icon} alt={action.title} className="log-action-image"/> */}
  //         <div className='op36-curriculum-image-card-container'>
  //           <img
  //             src={Op36Icon}
  //             alt={t('profile.common.operation36Curriculum')}
  //             className='op36-curriculum-image-card'
  //           />
  //         </div>
  //         <h5 className='log-action-title text-center'>{t('profile.common.op36Curriculum')}</h5>
  //         <h5 className='log-action-subtitle'>{t('profile.logActions.markStudentGoalsComplete')}</h5>
  //       </div>
  //       <div
  //         className={`card log-action-card col-md-4 log-action-goal-card ${
  //           this.state.actionSelected === 5 ? 'log-action-card-active' : ''
  //         }`}
  //         onClick={() => this.handleActionSelect(5)}
  //       >
  //         <i className='fa fa-plus log-action-goal-icon' />
  //         <h5 className='log-action-title text-center'>{t('profile.common.addPrivateGoal')}</h5>
  //         <h5 className='log-action-subtitle'>{t('profile.logActions.createCustomGoal')}</h5>
  //       </div>
  //     </div>
  //   )
  // }

  renderGoalForm() {
    const { t } = this.props
    return (
      <div className='row d-flex align-items-center flex-column h-100 mt-5'>
        <div className='col-md-12 mx-auto'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='form-group'>
                { this.props.objectives.length > 0 &&
                  !this.props.isRankCompleted &&
                  !this.props.loading ? (
                    <div>
                      <label htmlFor='objectives'>
                        {t('profile.logActions.selectLevelObjective', {
                          level: this.props.user.user_curriculums[0].rank_id,
                        })}
                      </label>
                      <select
                        className='form-control'
                        id='objectives'
                        onChange={this.props.handleRankObjectiveSelectChanged}
                        value={this.props.issueTrophyFormObjectiveId}
                      >
                        <option value={-1} disabled>
                          {t('profile.logActions.pleaseSelectObjective')}
                        </option>
                        {this.displayRankObjectives()}
                      </select>
                    </div>
                  ) : this.props.isRankCompleted && !this.props.loading ? null : (
                    <div className='row'>
                      <div className='col-12'>
                        <div className='loading-content goal-loading '>
                          <Loader message={t('profile.logActions.loadingGolferObjectives')} />
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  onObjectChange = (index, desc, progress, id) => {
    const goalTasks = [...this.state.goalTasks]

    goalTasks[index] = [progress, desc, id]
    this.setState(
      {
        goalTasks: goalTasks,
      },
      () => {
        const percentages = [0]

        this.state.goalTasks.map((task) => {
          percentages.push(task[0])
        })

        const total = percentages.reduce((acc, val) => acc + val)
        this.setState({
          goalCompletion: total,
        })
      }
    )
  }

  onSubmitTask = (_data, _index) => {
    const { closeLogActionsModal } = this.props
    const goalTasks = [...this.state.goalTasks]
    if (this.state.pictures.length > 0) {
      this.setState({
        uploadingPhoto: true,
      })
    }
    this.setState(
      {
        goalTasks: goalTasks,
        goalLoader: true,
      },
      () => {
        if (this.state.submitClicked) {
          this.setState({
            actionSelected: -1,
          })
          this.props.goal_actions
            .createGoal(this.state, goalTasks, getActiveCommunityId(this.props.current_user, this.props.activeCommunityId))
            .then((_res) => {
              this.props.user_actions
                .getUserGoals(this.props.user.id)
                .then(() => {
                  this.setState(
                    {
                      goalLoader: false,
                      uploadingPhoto: false,
                    },
                    () => {
                      closeLogActionsModal()
                      this.resetForms()
                    }
                  )
                })
            })
        }
      }
    )
  }

  renderPercentageText = () => {
    const { t } = this.props
    if (this.state.goalCompletion < 100) {
      return t('profile.logActions.objectiveImportanceHint')
    } else if (this.state.goalCompletion === 100) {
      return t('profile.logActions.objectivesAddedSuccess')
    } else if (this.state.goalCompletion > 100) {
      return t('profile.logActions.objectivesOverHundred')
    }
  }

  /*********
  Upload Photo on Goal
  *********/

  handlePictureChange = (event) => {
    if (event.target.files.length > 0) {
      const selectedFiles = event.target.files
      const { pictures } = this.state

      for (let i = 0; i < selectedFiles.length; i++) {
        pictures.push(selectedFiles.item(i))
      }
      this.setState({
        pictures: pictures,
      })
    }
  }

  resetPictures = () => {
    this.setState({
      pictures: [],
    })
  }

  // onChangePhoto = event => {
  //   if (event.target.value) {
  //     this.setState({
  //       uploadPhotoName: event.target.value,
  //       uploadPhotoFile: event.target.files[0],
  //       didUploadPhoto: true,
  //     });
  //     var reader = new window.FileReader();
  //     var page = this
  //     reader.onload = function (e) {
  //       page.setState({
  //         uploadPhotoFileSrc: e.target.result
  //       });
  //     }
  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // }
  //
  //
  selectInputFile() {
    document.getElementById('input-photo-upload').click()
  }

  displayImageSelect() {
    const { t } = this.props
    if (this.state.uploadingPhoto) {
      return (
        <div id='GoalImage' className='text-center uploading-images-container'>
          <i
            className='fa fa-circle-o-notch fa-spin fa-lg fa-3x uploading-images-icon'
            aria-hidden='true'
          />
          <p className='mt-2 uploading-images-text'>{t('profile.logActions.uploadingImages')}</p>
        </div>
      )
    } else {
      return (
        <ImageUploader
          label={t('profile.logActions.imageUploaderLabel')}
          reset={this.resetPictures}
          id='input-photo-upload'
          onChange={this.handlePictureChange}
          accept={'image/*'}
          selectImages={this.selectInputFile}
          images={this.state.pictures}
          imageSources={this.state.uploadPhotoFileSources}
        />
      )
    }
  }

  renderPrivateGoalForm() {
    const { t } = this.props
    return (
      <div className='row d-flex align-items-center flex-column h-100 mt-5'>
        <div className='col-md-12 mx-auto'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='col-md-12'>
                <div className='form-group'>
                  <label htmlFor='program-activity-title'>{t('profile.common.name')}</label>
                  <input
                    type='text'
                    name='goalName'
                    className='form-control'
                    id='goal-name'
                    placeholder={t('profile.logActions.goalNamePlaceholder')}
                    onChange={this.handleInputChange}
                    value={this.state.goalName}
                  />
                </div>
              </div>
              <div className='col-md-12'>
                <div className='form-group'>
                  <label htmlFor='program-activity-title'>
                    {t('profile.logActions.videoUrlOptional')}
                  </label>
                  <input
                    type='text'
                    name='goalVideo'
                    className='form-control'
                    id='goal-video'
                    placeholder={t('profile.logActions.goalVideoPlaceholder')}
                    onChange={this.handleInputChange}
                    value={this.state.goalVideo}
                  />
                </div>
              </div>
              <div className='col-md-12'>
                <div className='form-group'>
                  <label htmlFor='goalDescription'>{t('common.field.description')}</label>
                  <textarea
                    rows={3}
                    name='goalDescription'
                    className='form-control '
                    placeholder={t('profile.logActions.goalDescriptionPlaceholder')}
                    value={this.state.goalDescription}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='my-2 pl-2'>
                <label className='mt-3 my-0' htmlFor='goal-image'>
                  {t('profile.logActions.goalImageUploadOptional')}
                </label>
              </div>
              {/* <TextInput
                  name={''}
                  id={'input-photo-upload'}
                  type={'file'}
                  accept={"image/*"}
                  className={'form-control-file photoInput hide'}
                  onChange={this.onChangePhoto}
                  placeholder={'Add a Different Photo'}
                  value={this.state.uploadPhotoName}
                  error={''} /> */}
              {this.displayImageSelect()}
            </div>
            <div className='col-md-12 goal-objective-percentage-wrapper'>
              <label htmlFor='goalObjectives'>{t('profile.logActions.goalObjectives')}</label>
              <div className='goal-percentage-wrapper hidden-sm-down'>
                <p className='goal-percentage-desc'>
                  {this.renderPercentageText()}
                </p>
                <div
                  className='goal-percentage-tracker'
                  style={{
                    backgroundColor:
                      this.state.goalCompletion === 100 ? '#33d9b2' : '',
                  }}
                >
                  {t('profile.logActions.goalCompletion', { percentage: this.state.goalCompletion })}
                </div>
              </div>
            </div>
            {this.renderGoalTasks()}
            <div className='col-md-12 goal-objective-border' />
            <div className='col-md-12 goal-objective-icon-wrapper'>
              {this.state.goalTaskArray.length > 1 ? (
                <i
                  className='fa fa-minus goal-objective-minus-icon'
                  onClick={this.deleteGoalTask}
                />
              ) : null}
              <i
                className='fa fa-plus goal-objective-add-icon'
                onClick={this.createGoalTask}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderActiveForm = () => {
    const { showCreateGoal } = this.props
    if (showCreateGoal) {
      return this.renderPrivateGoalForm()
    } else {
      switch (this.state.actionSelected) {
        case 1:
          return this.renderPlayForm()
        case 2:
          return this.renderTrainForm()
        case 3:
          return this.renderPrivateGoalForm()
        case 4:
          if (!this.props.gotObjectives) {
            this.props.getUserRanks(this.props.user)
          }
          return this.renderGoalForm()
        default:
          return null
      }
    }
  }

  renderActiveButton() {
    const { showCreateGoal } = this.props
    if (showCreateGoal) {
      return !(this.state.goalName !== '' &&
        this.state.goalDescription !== '' &&
        this.state.goalCompletion === 100 &&
        !this.state.uploadingPhoto &&
        this.state.pictures.length <= 5)
    } else {
      switch (this.state.actionSelected) {
        case 1:
          return false
        case 2:
          return false
        case 3:
          return !(this.state.goalName !== '' &&
            this.state.goalDescription !== '' &&
            this.state.goalCompletion === 100 &&
            !this.state.uploadingPhoto &&
            this.state.pictures.length <= 5)
        case 4:
          return false
        default:
          return true
      }
    }
  }

  renderUpdateText() {
    const { showCreateGoal, t } = this.props
    if (showCreateGoal) {
      return t('profile.common.addPrivateGoal')
    } else {
      switch (this.state.actionSelected) {
        case 1:
          return t('profile.logActions.logRound')
        case 2:
          return t('profile.logActions.logPracticeSession')
        case 3:
          return t('profile.common.addPrivateGoal')
        case 4:
          return t('profile.logActions.logGoal')
        default:
          return t('profile.logActions.applyingChanges')
      }
    }
  }

  renderModalTitle() {
    const { showCreateGoal, t } = this.props
    if (showCreateGoal) {
      return t('profile.logActions.newPrivateGoal')
    } else {
      switch (this.state.actionSelected) {
        case 1:
          return t('profile.logActions.logRound')
        case 2:
          return t('profile.logActions.logPractice')
        case 3:
          return t('profile.logActions.newPrivateGoal')
        case 4:
          return t('profile.logActions.logGoal')
        case 5:
          return t('profile.logActions.newPrivateGoal')
        default:
          return t('profile.logActions.logActionsTitle')
      }
    }
  }

  // Render Main Content

  modalBack = (previous) => {
    this.setState(
      {
        actionSelected: -1,
      },
      () => {
        previous()
      }
    )
  }

  render() {
    const { userLoader, showCreateGoal, t } = this.props
    return (
      <div>
        <Modal
          isOpen={this.props.showLogActionsModal}
          contentLabel={t('profile.logActions.logActionsTitle')}
        >
          <div style={{ overflowX: 'hidden' }}>
            <div className='modal-header row'>
              <div className='col-10'>
                {userLoader ? (
                  <h5 className='modal-title display-4 uppercase detail-title'>
                    {t('profile.logActions.loadingGolfer')}
                  </h5>
                ) : (
                  <h5 className='modal-title display-4 uppercase detail-title'>
                    {t('profile.logActions.modalTitleForGolfer', {
                      title: this.renderModalTitle(),
                      firstName: this.props.user ? this.props.user.first_name : '',
                      lastName: this.props.user ? this.props.user.last_name : '',
                    })}
                  </h5>
                )}
              </div>
              <div className='col-2'>
                <button
                  type='button'
                  className='close pull-right font-200 modal-close-btn'
                  data-dismiss='modal'
                  aria-label={t('common.close')}
                  onClick={this.props.closeLogActionsModal}
                >
                  <span aria-hidden='true'>✕</span>
                </button>
              </div>
            </div>
            <div className='modal-content container p-3'>
              <ActiveCommunityNotice />
              {userLoader ? (
                <Loader message={t('profile.logActions.loadingGolferLoader')} />
              ) : (
                <Wizard>
                  <Steps>
                    <Step
                      id='step1'
                      render={({ previous: _, next }) => (
                        <div>
                          <div className='row mx-auto pb-5 mb-5'>
                            {this.logActionsWelcome(next)}
                          </div>
                          <div className='row bg-white pb-3'>
                            <div className='col-6 mx-auto'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <button
                                    className='btn btn-block btn-primary'
                                    onClick={next}
                                    disabled={this.state.actionSelected <= 0}
                                  >
                                    {t('common.flow.next')}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    />
                    <Step
                      id='step2'
                      render={({ previous, next: _ }) => (
                        <div className='pb-5 mb-5'>
                          {this.renderActiveForm()}
                          <div className='row bg-white pb-3'>
                            <div className='col-6 mx-auto'>
                              <div className='row'>
                                {!showCreateGoal && (
                                  <div className='col-md-6'>
                                    <button
                                      className='btn w-100 btn-dark log-actions-button'
                                      onClick={() => this.modalBack(previous)}
                                    >
                                      {t('profile.common.previous')}
                                    </button>
                                  </div>
                                )}

                                <div
                                  className={`col-md-6 ${
                                    showCreateGoal ? 'mx-auto' : ''
                                  }`}
                                >
                                  <button
                                    className='btn btn-block btn-primary text-center log-actions-button'
                                    onClick={() => this.handleLogClick()}
                                    disabled={this.renderActiveButton()}
                                  >
                                    {this.renderUpdateText()}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    />
                  </Steps>
                </Wizard>
              )}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

LogActionsModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    user_curriculums: PropTypes.arrayOf({
      rank_id: PropTypes.number,
    }),
    communities: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
  }),
  actions: PropTypes.shape({
    getUserActivities: PropTypes.func,
  }),
  activity_actions: PropTypes.object,
  goal_actions: PropTypes.object,
  objectives: PropTypes.shape({
    length: PropTypes.number,
  }),
  current_user: PropTypes.shape({
    type: PropTypes.string,
  }),
  playTypes: PropTypes.array,
  isRankCompleted: PropTypes.func,
  loading: PropTypes.bool,
  handleRankObjectiveSelectChanged: PropTypes.func,
  issueTrophyFormObjectiveId: PropTypes.number,
}

LogActionsModal.propTypes = {
  toggleValidationModal: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(userActions, dispatch),
    activity_actions: bindActionCreators(activityActions, dispatch),
    objective_actions: bindActionCreators(objectiveActions, dispatch),
    goal_actions: bindActionCreators(goalActions, dispatch),
    user_actions: bindActionCreators(userActions, dispatch),
  }
}

LogActionsModal.propTypes = {
  activeCommunityId: PropTypes.number,
  setActivityAdded: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    activeCommunityId: state.user.active_community_id,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogActionsModal))
